import React, { forwardRef, useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
export const Buttons = forwardRef(({ title, handleClick, icon }, ref) => {
  return (
    <button
      ref={ref}
      onClick={handleClick}
      className="buttons px-[0.8rem] sm:px-[1.2rem] font-Syne rounded-[33px] text-[#000]
       text-[18px] font-syne flex items-center justify-center gap-2 bg-background-black"
    >
      {title} {icon}
    </button>
  );
});

export const WhiteButton = forwardRef(({ title, handleClick, icon }, ref) => {
  return (
    <button
      ref={ref}
      onClick={handleClick}
      className="
    group flex items-center font-Syne justify-center gap-2 w-[250px] py-3 rounded-[30px] 
    bg-button-black text-white text-[18px] font-syne  border
    hover:bg-button-black hover:border hover:border-white hover:text-white 
    transition-all duration-500 ease-in-out
  "
    >
      {title} {icon}
    </button>
  );
});

export const TabButton = ({ title, handleClick, isActive }, ref) => {
  return (
    <button
      ref={ref}
      onClick={handleClick}
      className={`px-[1.2rem] py-[0.6rem] rounded-[33px] text-[#000000] text-[18px] 
  [font-family:"Syne",sans-serif] ${isActive ? "tab-button active" : "tab-button"}`}
    >
      {title}
    </button>
  );
};

export const BlackButton = forwardRef(
  ({ title, handleClick, icon, width }, ref) => {
    return (
      <button
        ref={ref}
        onClick={handleClick}
        className={`
    group flex items-center font-Syne justify-center gap-2 px-5 py-1 rounded-[30px] 
    bg-black text-[18px] text-white font-semibold border
    hover:bg-transparent hover:border hover:border-black hover:text-black 
    transition-all duration-500 ease-in-out `}
      >
        {title} {icon}
      </button>
    );
  },
);

export const PasswordInput = ({
  label,
  name,
  value,
  onChange,
  placeholder,
}) => {
  const [show, setShow] = useState(false); // default hidden

  return (
    <div className="relative items-center">
      <label className="block mb-1 font-medium">{label}</label>
      <input
        type={show ? "text" : "password"} // toggle type
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black pr-10"
      />
      {/* Eye icon */}
      <span
        className="absolute right-2 top-[3rem] transform -translate-y-1/2 cursor-pointer text-gray-500"
        onClick={() => setShow(!show)}
      >
        {show ? <FaRegEyeSlash size={20} /> : <FaRegEye size={20} />}{" "}
        {/* simple emoji toggle, can use icons */}
      </span>
    </div>
  );
};
